module.exports = "/reports/components/userTimeoffTableComponent-98c266.html";